// src/components/AdminProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AdminProtectedRoute = ({ children }) => {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!user || role !== "admin") {
    // If user is not logged in or not admin, redirect them away
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminProtectedRoute;
